import React, {Fragment} from 'react';
import createForm from "./Form";
import {optionsTemplate, ProductColumn, UnitFormatter} from "../../../utils/formatters";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import DateTimeInput from "../../form/DateTimeInput";
import ImportButton from "../../form/ImportButton";
import {ifCompletedInput} from "../../../utils/other";
import ComponentField from "../../form/ComponentField";
import TextArea from '../../form/TextArea';
import isEqual from "lodash-es/isEqual";
import {connect} from "src/store";
import get from "../../../utils/get";

export class ClientComponent extends React.Component {

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (!isEqual(prevProps.context, this.props.context) || get(this.props.context, "client.partner_id") !== this.props.values.partner.partner_id) {
            this.props.setFieldValue && this.props.setFieldValue("partner", get(this.props.context, "client.partner_id"));
        }
    }

    render() {
        return (
            <Select
                objectValue={true}
                name="partner"
                value={this.props.values.partner}
                labelKey="name"
                valueKey="partner"
                component="partner"
                storeType="remote"
                saveChanges={this.props.setFieldValue}
                label="Partner"
                {...this.props.getFieldProps("partner")}
                disabled={true}
            />
        );
    }
}

const Client = connect((state) => {
    return {
        context: state.app.context
    };
}, {})(ClientComponent);

class StoreOrderBuilderForm extends React.Component {

    render() {
        const valid = this.props.componentConfig?.config?.damaged_id_validation && new RegExp(this.props.componentConfig?.config?.damaged_id_validation).test(this.props.values?.xtradata?.booklog_id);
        return (
            <form onSubmit={this.props.handleSubmit}>
                {!this.props.isDamaged(this.props) ? <Fragment>
                    <div className="row form-row">
                        <div className="col-sm-6">
                            <div className="form-group">
                                <TextInput
                                    name="external_id"
                                    label="Külső rendelésszám"
                                    value={this.props.values.external_id}
                                    saveChanges={this.props.setFieldValue}
                                    {...this.props.getFieldProps("external_id")}
                                />
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <TextInput
                                    name="notenum"
                                    label="Szállítólevél szám"
                                    value={this.props.values.notenum}
                                    saveChanges={this.props.setFieldValue}
                                    {...this.props.getFieldProps("notenum")}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row form-row">
                        <div className="col-sm-4">
                            <div className="form-group">
                                <Client {...this.props} />
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="form-group">
                                {(this.props.values.partner || {}).partner_id && <Select
                                    component="apilocation"
                                    name="apilocation"
                                    storeType="local"
                                    value={this.props.values.apilocation}
                                    label={this.props.in ? "Szállító" : "Cimzett"}
                                    labelKey="name"
                                    filter={[{field: "client", value: (this.props.values.partner || {}).partner_id}]}
                                    saveChanges={this.props.setFieldValue}
                                    {...this.props.getFieldProps("apilocation")}
                                />}
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="form-group">
                                <DateTimeInput
                                    name="transactiondate"
                                    value={this.props.values.transactiondate}
                                    label="Teljesítés dátuma"
                                    showTime={false}
                                    minDate={new Date()}
                                    saveChanges={this.props.setFieldValue}
                                />
                            </div>
                        </div>
                    </div>
                </Fragment> : <Fragment>
                    <div className="row form-row">
                        <div className="col-md-12">
                            <TextInput
                                name="xtradata.booklog_id"
                                label="Booklog azonosító"
                                value={this.props.values?.xtradata?.booklog_id}
                                saveChanges={this.props.setFieldValue}
                                error={!valid ? "Nem megfelelő!" : null}
                                valid={valid}
                            />
                        </div>
                        <div className="col-md-12">
                            <div className="form-group">
                                <Select
                                    component="partner"
                                    name="partner"
                                    storeType="remote"
                                    value={this.props.values.partner}
                                    label={"Partner"}
                                    labelKey="name"
                                    saveChanges={this.props.setFieldValue}
                                    {...this.props.getFieldProps("partner")}
                                    disabled={true}
                                />
                            </div>
                        </div>
                    </div>
                </Fragment>}
                <div className="row form-row">
                    <div className="col-sm-12">
                        <div className="form-group">
                            <TextArea
                                name="comment"
                                value={this.props.values.comment}
                                label="Megjegyzés"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("comment")}
                            />
                        </div>
                    </div>
                    {!this.props.isDamaged(this.props) && <div className="col-sm-12">
                        <div className="form-group">
                            <ComponentField
                                getFieldProps={this.props.getFieldProps}
                                componentConfig={this.props.componentConfig}
                                name="delivery_note"
                                values={this.props.values}
                                setFieldValue={this.props.setFieldValue}
                                label="Szállítólevél"
                                documentType={1}
                            />
                        </div>
                    </div>}
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <div className="form-group">
                            <SelectorGrid
                                ref={(e) => this.items = e}
                                className={"p-small-table"}
                                exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel"}]}
                                view={["product_id"]}
                                columns={{
                                    "name": {
                                        ...ProductColumn("product_id"),
                                        width: 2,
                                    },
                                    "barcode": {
                                        header: "Vonalkód",
                                        width: 1,
                                        sortable: true,
                                        filterable: true,
                                    },
                                    "qty": {
                                        header: 'Összesen',
                                        width: 1,
                                        sortable: true,
                                        filterable: true,
                                        renderer: (value, row) => UnitFormatter(value, row.unit),
                                        editor: !this.props.isDamaged(this.props) ? (parent) => (props, value) =>
                                            <TextInput
                                                type="number"
                                                name="qty"
                                                label={false}
                                                focus
                                                value={value}
                                                onKeyDown={(e, field, value) => {
                                                    ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                                }}
                                                onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}
                                            /> : null
                                    },
                                }}
                                addRowProps={!this.props.isDamaged(this.props) ? {
                                    component: "product",
                                    filter: [
                                        {
                                            field: "partners.partner_id",
                                            value: this.props.values.partner.partner_id
                                        }
                                    ],
                                    optionsTemplate: optionsTemplate("product")
                                } : null}
                                onAddRows={!this.props.isDamaged(this.props) ? (items) => items.map((item) => ({...item, product_id: item.id, qty: 1})) : null}
                                {...({
                                    name: !this.props.isDamaged(this.props) ? "items" : null,
                                    listfield: this.props.isDamaged(this.props) ? "items" : null
                                })}
                                data={this.props.values}
                                orderBy={{field: "name", direction: "ASC"}}
                                componentConfig={this.props.componentConfig}
                                onItemUpdate={!this.props.isDamaged(this.props) ? true : null}
                                paginatorRight={() => <ImportButton
                                    {...this.props.getFieldProps("import")}
                                    data={this.props.values}
                                    disabled={!this.props.values[this.props.componentConfig.idfield]}
                                    componentConfig={this.props.componentConfig}
                                    label={false}
                                    name="file"
                                    saveChanges={this.props.importFile}
                                />}
                            />
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="form-group">
                            <TextInput
                                name="label"
                                label="Címke"
                                value={this.props.values.label}
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("label")}
                            />
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(StoreOrderBuilderForm);
